export default __webpack_public_path__ + "static/char-s-53-zh-Hans-46d5b5bfa3334a72afcd009df9839696.png";